export default __webpack_public_path__ + "static/media/layout-background-secondary.c8effa91.svg";